import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useAbility } from '@casl/react';
import AccessDenied from 'components/AccessDenied';
import { PermissionsContext, ACTIONS } from 'context/Permissions';
import { useFlags } from 'launchdarkly-react-client-sdk';
var AccessGuard = function (_a) {
    var children = _a.children, flag = _a.flag, permissionSubject = _a.permissionSubject, fallback = _a.fallback;
    var flags = useFlags();
    var ability = useAbility(PermissionsContext);
    if (flag) {
        var isFeatureEnabled = flags[flag];
        if (!isFeatureEnabled)
            return _jsx(_Fragment, { children: fallback || null });
    }
    if (permissionSubject) {
        var hasPermission = ability.can(ACTIONS.READ, permissionSubject);
        if (!hasPermission)
            return _jsx(_Fragment, { children: fallback || _jsx(AccessDenied, {}) });
    }
    return _jsx(_Fragment, { children: children });
};
export default React.memo(AccessGuard);
